// extracted by mini-css-extract-plugin
export default {"bodyContainer":"Body_bodyContainer__CbNmp"};